import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=26b9fb20&scoped=true"
import script from "./Applications.vue?vue&type=script&lang=js"
export * from "./Applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b9fb20",
  null
  
)

export default component.exports